module.exports = __webpack_public_path__ + "img/fe1b2a7.jpg";